/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Command_CalculatorInputs */

const he_command_calculator = /** @type {(inputs: Command_CalculatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחשבון`)
};

const en_command_calculator = /** @type {(inputs: Command_CalculatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculator`)
};

/**
* | output |
* | --- |
* | "Calculator" |
*
* @param {Command_CalculatorInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const command_calculator = /** @type {((inputs?: Command_CalculatorInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Command_CalculatorInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_command_calculator(inputs)
	return en_command_calculator(inputs)
});